import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Landing.css';

export default function Landing() {
  const { t } = useTranslation();
  return (
    <main className="landing">
      <header className="landing__top" />
      <section className="landing__hero">
        <h1>{t('hero_title')}</h1>
        <div className="landing__cta">
          <Link to="/login" className="btn primary">{t('cta_login')}</Link>
          <Link to="/contact-us" className="btn secondary">{t('cta_contact')}</Link>
        </div>
      </section>
      <section className="landing__features">
        <div className="features__wrap">
          <div className="features__text">
            <h2>{t('features_title')}</h2>
            <ul className="features__list">
              <li>{t('f_realtime')}</li>
              <li>{t('f_recurring')}</li>
              <li>{t('f_calendar')}</li>
              <li>{t('f_access')}</li>
            </ul>
          </div>
          <img src="/demo.png" alt="Product demo" className="features__img" />
        </div>
      </section>
    </main>
  );
}
